// extracted by mini-css-extract-plugin
module.exports = {"ml-0_50":"style_ml-0_50__uWcYz"};